import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "20",
  fill: "none",
  viewBox: "0 0 21 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#000",
  d: "M11.667 14.357h-.154l-.127.086-6.022 4.084a.5.5 0 0 1-.78-.414v-3.756H2a1.5 1.5 0 0 1-1.5-1.5V2A1.5 1.5 0 0 1 2 .5h17A1.5 1.5 0 0 1 20.5 2v10.857a1.5 1.5 0 0 1-1.5 1.5z",
  opacity: ".5"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "gray",
  d: "M9.876 4.482h1.348c1.213 0 1.799.645 1.799 1.659 0 1.02-.592 1.67-1.8 1.67H9.877zm2.432 6.17v-.797H9.876v-1.13h1.611c1.588 0 2.62-1.096 2.62-2.584 0-1.483-1.02-2.596-2.608-2.596H8.821V7.81H7.65v.914H8.82v1.13H7.65v.797H8.82V12h1.055v-1.348z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }